import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFiles,
	DetailsSectionImage,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionNotes from 'app/main/submodules/notes/DetailsSectionNotes';

import CommunicationsDetailsSectionInfo from '../sections/CommunicationsDetailsSectionInfo';

export default function CommunicationsDetailsTab(props: DetailsPageContentProps) {
	const { sysSettings, t } = useSettings();

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<CommunicationsDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionDescription
							name="coms_descriptionhtml"
							value={props.model.coms_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="communications" uid={props.model.coms_uid} />
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ sm: 4, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionImage
							title={t('DETAILS_THUMBNAIL_SECTION')}
							subheader={t('DETAILS_THUMBNAIL_SUBHEADER')}
							isEdit={props.isEdit}
							fieldName="coms_image"
							fileName={props.model.coms_uid}
							path="communications/thumbnails"
							value={props.model.coms_image}
							sendChange={props.sendFilesChange}
						/>
					</Grid>
					{!props.isAdd && !!props.model.coms_foldername && (
						<Grid size={12}>
							<DetailsSectionFiles
								icon={<Icon icon="attachment" />}
								title={t('DETAILS_ATTACHED_FILES_SECTION')}
								subheader={t('DETAILS_ATTACHED_FILES_SUBHEADER')}
								folderPath={`${sysSettings.docs_path}${props.model.coms_foldername}`}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
